"use client"

import { motion } from "framer-motion"
import { BiLoaderCircle } from "react-icons/bi"

export default function AnimatedLoader({ text = "Chargement..." }) {
  const containerVariants = {
    start: {
      transition: {
        staggerChildren: 0.2,
      },
    },
    end: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const circleVariants = {
    start: {
      y: "0%",
    },
    end: {
      y: "100%",
    },
  }

  const circleTransition = {
    duration: 0.5,
    repeat: Number.POSITIVE_INFINITY,
    repeatType: "reverse",
    ease: "easeInOut",
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <motion.div
        className="mb-5"
        animate={{
          rotate: 360,
          scale: [1, 1.2, 1],
        }}
        transition={{
          rotate: {
            duration: 2,
            repeat: Number.POSITIVE_INFINITY,
            ease: "linear",
          },
          scale: {
            duration: 1,
            repeat: Number.POSITIVE_INFINITY,
            repeatType: "reverse",
          },
        }}
      >
        <BiLoaderCircle className="display-1 text-primary" />
      </motion.div>

      <motion.div variants={containerVariants} initial="start" animate="end" className="d-flex gap-1 mb-3">
        {[0, 1, 2].map((index) => (
          <motion.div
            key={index}
            variants={circleVariants}
            transition={{
              ...circleTransition,
              delay: index * 0.1,
            }}
            className="bg-primary rounded-circle"
            style={{ width: "8px", height: "8px" }}
          />
        ))}
      </motion.div>

      <motion.p
        className="text-muted mb-0"
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{
          duration: 1.5,
          repeat: Number.POSITIVE_INFINITY,
          repeatType: "reverse",
        }}
      >
        {text}
      </motion.p>
    </div>
  )
}
